"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isAttrOptionsRestriction = isAttrOptionsRestriction;
exports.isAttrRestriction = isAttrRestriction;
exports.isAttributeRestriction = isAttributeRestriction;
function isAttrOptionsRestriction(r) {
  return r.optionsFor && typeof r.optionsFor === 'string' && r.options && Array.isArray(r.options) && r.options.reduce((acc, option) => acc && typeof option === 'string', true);
}
function isAttrRestriction(r) {
  return r.attribute && typeof r.attribute === 'string';
}
function isAttributeRestriction(ar) {
  return ar && ar.disable && (isAttrRestriction(ar.disable) || isAttrOptionsRestriction(ar.disable)) && ar.if && ar.if.attribute && typeof ar.if.attribute === 'string' && ar.if && ar.if.equals && typeof ar.if.equals === 'string';
}